import { useMutation } from 'react-query';

import { NewComment, createComment } from '@utils/backend-api/comments';

export default function useCommentCreate() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation((values: NewComment) =>
    createComment(values)
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
